export const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '36px',
    paddingBottom: 0,
    gap: '16px',
    height: 'calc(100vh - 70px)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerTitle: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  label: {
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '17px',
    color: '#004EEB',
    padding: '2px 8px',
    textAlign: 'center',
    borderRadius: '16px',
    backgroundColor: '#EFF4FF',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'end',
    gap: '16px',
  },
  avatarContainer: {
    paddingLeft: '24px',
  },
  avatar: {
    width: '34px',
    height: '34px',
  },
};
